import { useCallback } from 'react';

const useCloseAndReset = ({
  onClose,
  resetSession,
  setFormState,
  setInitialFormValues,
  setIsTouched,
  setValidationErrors,
  discardCustomFields,
}) =>
  useCallback(() => {
    resetSession();
    setFormState({});
    setInitialFormValues({});
    setIsTouched(false);
    setValidationErrors({});
    discardCustomFields();
    onClose();
  }, [
    discardCustomFields,
    onClose,
    resetSession,
    setFormState,
    setInitialFormValues,
    setIsTouched,
    setValidationErrors,
  ]);

export default useCloseAndReset;
